import { api } from '@/api/api';
export class ContactSelectProxy {
    constructor() {
        this.selectWhiteList = [];
        this.eventApi = api.getEventApi();
        this.recentSelectContactMap = new Map();
        this.recentSelectOrgMap = new Map();
        this.sendMaxTime = 3 * 1000;
    }
    sendSelectContactNotify(force) {
        console.log('[contact_proxy] sendSelectContactNotify ', this.recentSelectContactMap.size, this.selectContactNotifyTimer);
        if (this.recentSelectContactMap.size >= 30 || force) {
            const list = [...this.recentSelectContactMap.values()];
            this.eventApi.sendSysEvent({
                eventName: 'selectContactNotify',
                eventData: list,
            });
            this.recentSelectContactMap.clear();
            if (this.selectContactNotifyTimer) {
                clearTimeout(this.selectContactNotifyTimer);
                this.selectContactNotifyTimer = undefined;
            }
        }
        else if (!this.selectContactNotifyTimer) {
            this.selectContactNotifyTimer = window.setTimeout(() => {
                console.log('[contact_proxy] auto sendSelectContactNotify');
                const list = [...this.recentSelectContactMap.values()];
                this.eventApi.sendSysEvent({
                    eventName: 'selectContactNotify',
                    eventData: list,
                });
                this.recentSelectContactMap.clear();
                if (this.selectContactNotifyTimer) {
                    clearTimeout(this.selectContactNotifyTimer);
                    this.selectContactNotifyTimer = undefined;
                }
            }, this.sendMaxTime);
            console.log('[contact_proxy] start setTimeout', this.selectContactNotifyTimer);
        }
    }
    sendSelectOrgNotify(force) {
        console.log('[contact_proxy] recentSelectOrgMap ', this.recentSelectOrgMap.size, this.recentSelectOrgMapTimer);
        if (this.recentSelectOrgMap.size >= 30 || force) {
            const list = [...this.recentSelectOrgMap.values()];
            this.eventApi.sendSysEvent({
                eventName: 'selectOrgNotify',
                eventData: list,
            });
            this.recentSelectOrgMap.clear();
            if (this.recentSelectOrgMapTimer) {
                clearTimeout(this.recentSelectOrgMapTimer);
                this.recentSelectOrgMapTimer = undefined;
            }
        }
        else if (!this.recentSelectOrgMapTimer) {
            this.recentSelectOrgMapTimer = window.setTimeout(() => {
                console.log('[contact_proxy] auto sendSelectContactNotify');
                const list = [...this.recentSelectOrgMap.values()];
                this.eventApi.sendSysEvent({
                    eventName: 'selectOrgNotify',
                    eventData: list,
                });
                this.recentSelectOrgMap.clear();
                if (this.recentSelectOrgMapTimer) {
                    clearTimeout(this.recentSelectOrgMapTimer);
                    this.recentSelectOrgMapTimer = undefined;
                }
            }, this.sendMaxTime);
            console.log('[contact_proxy] start setTimeout', this.recentSelectOrgMapTimer);
        }
    }
    addRecentSelectContactMap(list, force) {
        console.log('[contact.selectnotify]addRecentSelectContact', list, force);
    }
    addRecentSelectOrgMap(list, force) {
        console.log('[contact.selectnotify]addRecentSelectOrgMap', list, force);
    }
    async handleNeedTransData(key, data) {
        var _a, _b, _c;
        try {
            if (!this.selectWhiteList.includes(key)) {
                throw new Error(key + 'not in selectWhiteList');
            }
            if (key === 'doGetPersonalOrg') {
                const { success, data: orgList } = data;
                if (success && orgList) {
                    orgList.forEach(item => this.recentSelectOrgMap.set(item.id, item));
                    this.sendSelectOrgNotify();
                }
                return;
            }
            let list = [];
            switch (key) {
                case 'doGetContactByEmails':
                    data.forEach(item => this.recentSelectContactMap.set(item.contact.contact.id, item.contact));
                    break;
                case 'doGetOrgContactListByTeamId':
                    data.forEach(item => {
                        if (Array.isArray(item)) {
                            item.forEach(({ model }) => {
                                if (model) {
                                    this.recentSelectContactMap.set(model.contact.id, model);
                                }
                            });
                        }
                        else {
                            const { model } = item;
                            if (model) {
                                this.recentSelectContactMap.set(model.contact.id, model);
                            }
                        }
                    });
                    break;
                case 'doSearchAllContact':
                    list = (_a = data) === null || _a === void 0 ? void 0 : _a.contactList;
                    if (list === null || list === void 0 ? void 0 : list.length) {
                        list.forEach(item => this.recentSelectContactMap.set(item.contact.id, item));
                    }
                    break;
                case 'doSearchTeamContact':
                    list = (_b = data) === null || _b === void 0 ? void 0 : _b.contactList;
                    if (list === null || list === void 0 ? void 0 : list.length) {
                        list.forEach(item => this.recentSelectContactMap.set(item.contact.id, item));
                    }
                    break;
                case 'doGetContactByYunxin':
                    list = (_c = data) === null || _c === void 0 ? void 0 : _c.contactModelList;
                    if (list === null || list === void 0 ? void 0 : list.length) {
                        list.forEach(item => this.recentSelectContactMap.set(item.contact.id, item));
                    }
                    break;
                default:
                    list = data;
                    if (list === null || list === void 0 ? void 0 : list.length) {
                        list.forEach(item => this.recentSelectContactMap.set(item.contact.id, item));
                    }
                    break;
            }
        }
        catch (e) {
            console.error('[contact_select_notify] handleNeedTransData', e, key, data);
        }
        this.sendSelectContactNotify();
    }
}
export default new ContactSelectProxy();
